<label
  class="form-label text-nowrap mb-0"
  [ngClass]="{'text-danger': (odometerInput.invalid && odometerInput.touched) || (odometerRadio.invalid && odometerRadio.touched)}"
>
  Current Odometer <span class="required">*</span>
</label>
<div class="input-group">
  <input
    #odometerInput="ngModel"
    [disabled]="claimDto.isLocked"
    [readOnly]="claimDto.isLocked"
    [ngClass]="{'is-invalid': (odometerInput.invalid && odometerInput.touched) || (odometerRadio.invalid && odometerRadio.touched)}"
    class="form-control"
    [(ngModel)]="claimDto.odometerReading"
    (keyup)="debounceOdometerUpdate()"
    type="number"
    required
  >
  <div
    class="input-group-text rounded-end pb-0"
    [ngClass]="{'border-danger': odometerRadio.invalid && odometerRadio.touched}"
  >
    <label class="form-check me-3">
      <input
        #odometerRadio="ngModel"
        [disabled]="claimDto.isLocked"
        [readOnly]="claimDto.isLocked"
        [ngClass]="{'is-invalid': odometerRadio.invalid && odometerRadio.touched}"
        class="form-check-input"
        type="radio"
        value="km"
        name="odometerType"
        [(ngModel)]="claimDto.odometerUnits"
        (change)="updateOdometer()"
        required
      >
      km
    </label>
    <label class="form-check">
      <input
        [disabled]="claimDto.isLocked"
        [readOnly]="claimDto.isLocked"
        [ngClass]="{'is-invalid': odometerRadio.invalid && odometerRadio.touched}"
        class="form-check-input"
        type="radio"
        value="mi"
        name="odometerType"
        [(ngModel)]="claimDto.odometerUnits"
        (change)="updateOdometer()"
        required
      >
      mi
    </label>
  </div>
  <div 
    *ngIf="(odometerInput.invalid && odometerInput.touched)"
     class="invalid-feedback lh-sm"
  >
    Please provide the odometer reading.
  </div>
  <div 
    *ngIf="odometerRadio.invalid && odometerRadio.touched && odometerInput.valid"
    class="invalid-feedback lh-sm"
  >
    Please choose an odometer unit.
  </div>
</div>
